import { get, download } from './client';

export function getProductPlacementVPI(growerId) {
  return get(`/growers/${growerId}/product-placement-vpi`);
}

export function downloadVarietyRecommendationPdf(growerId, aaids) {
  return download(
    `/product-placement-vpi/${growerId}/pdf/variety-recommendation`,
    aaids,
  );
}
